import { VehicleListSearchParams } from "@/app/Vehicles/Routes/vehicleRoutes";
import { QueryVehiclesOrderByColumn, SortOrder } from "@/gql/graphql";
import { VariablesOf } from "@graphql-typed-document-node/core";
import { vehicleListQuery } from "@/app/Vehicles/GraphQL/vehicleListQuery";

export function getVehicleListQueryVariables(
  searchParams: VehicleListSearchParams,
  supplierId: string | null,
): VariablesOf<typeof vehicleListQuery> {
  const baseParams: VariablesOf<typeof vehicleListQuery> = {
    page: 1,
    first: 20,
    search: searchParams.vehicleSearch || undefined,
    supplier_id: supplierId ?? undefined,
  };

  if (searchParams.vehicleSearch) {
    return baseParams;
  }

  return {
    ...baseParams,
    orderBy: [
      {
        order: SortOrder.Desc,
        column: QueryVehiclesOrderByColumn.Id,
      },
    ],
  };
}
